import { BaseRepository } from "@/repositories/base-repository"
import { type IMachine } from "@/interfaces/api/machine.interface"

export class MachineRepository extends BaseRepository<IMachine> {
  protected resourcePath = "planning/machines"
}
